module.exports = __webpack_public_path__ + "static/refrigerated-207ec6f7dd60ebcd6ff2f09f06453ce6.svg";